// frontend/src/components/InactivityTimeout.jsx
import { useState, useCallback } from 'react';
import useInactivityTimeout from '../hooks/useInactivityTimeout';
import InactivityWarningModal from './InactivityWarningModal';

/**
 * Component that wraps the inactivity timeout functionality
 * Add this to your App.js to enable inactivity timeout for all logged-in users
 */
const InactivityTimeout = () => {
    const [showWarning, setShowWarning] = useState(false);

    // Configuration
    const WARNING_MINUTES = 0.25;   // Show warning X minutes before logout
    const TIMEOUT_MINUTES = 15;  // Total inactivity time before logout

    // Wrap callbacks in useCallback to prevent infinite loops
    const handleWarning = useCallback(() => {
        setShowWarning(true);
    }, []);

    const handleLogout = useCallback(() => {
        // User is automatically redirected to login by the hook
        // No toast needed - the modal closing provides feedback
    }, []);

    // Initialize inactivity timeout hook
    const { extendSession, performLogout } = useInactivityTimeout({
        timeoutMinutes: TIMEOUT_MINUTES,
        warningMinutes: WARNING_MINUTES,
        onWarning: handleWarning,
        onLogout: handleLogout
    });

    // Handle "Stay Logged In" button click
    const handleStayLoggedIn = () => {
        setShowWarning(false);
        extendSession();
    };

    // Handle "Logout Now" button click
    const handleLogoutNow = () => {
        setShowWarning(false);
        performLogout();
    };

    return (
        <InactivityWarningModal
            show={showWarning}
            onStayLoggedIn={handleStayLoggedIn}
            onLogout={handleLogoutNow}
            countdownSeconds={WARNING_MINUTES * 60}
        />
    );
};

export default InactivityTimeout;